<template>
    <div class="yq-section">
        <div class="yq-section-head">
            <div class="yq-section-title">
                <slot v-if="$slots.title" name="title"></slot>
                <span v-else>{{title}}</span>
            </div>
            <div class="yq-section-toolbar">
                <slot name="toolbar"></slot>
            </div>
        </div>
        <div class="yq-section-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PortalSection",
        props: {
            title: String
        }
    }
</script>

<style scoped>

</style>
